import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import NavBar from "../../NavBar";
import { Button, ImageListItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  getVehicles,
  setSelectedVehicleDetails,
} from "../../redux/vehicle/action";
import { useDispatch } from "react-redux";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { getVehicleType } from "../../utils";
import storePersist, { localConstant } from "../../services/localStorage";
import vehiclePlaceHolderImage from "../../assets/images/vehicle_placeholder.jpeg";
import { useResponsive } from "../../hooks/useResponsive";
import addVehiclePlaceHolder from "../../assets/svg/addvehicle_placeholder.svg";
import { useRef } from "react";
import MenuBar from "../menuBar";
import CustomLoader from "../../components/CustomLoader";
import BottomNav from "../../components/BottomNav/BottomNav";
import CustomDialog from "../../components/CustomDialog";
import AddVehicles from "./addVehicles";
import { useTranslation } from "react-i18next";

const VehiclesList = () => {
  const [vehiclesList, setVehiclesList] = useState([]);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lgUp = useResponsive("up", "lg");
  const smDown = useResponsive("down", "sm");
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);

  const entity_customer_id = storePersist.get(localConstant.ENTITY_CUSTOMER_ID);

  useEffect(() => {
    dispatch(
      getVehicles({ cust_id: entity_customer_id }, (data) => {
        if (!data[0]?.errorMessage) {
          setVehiclesList([]);
          setVehiclesList(data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      }),
    );
  }, []);

  const handleListItemClick = (vehicle) => {
    dispatch(setSelectedVehicleDetails(vehicle));
    navigate("/vehicleDetails");
  };

  const myRef = useRef({});
  const getVehicleSource = (vehicle) => {
    const fileUploadResponse = vehicle?.fileUploadResponse
      ? vehicle?.fileUploadResponse[0]
      : "";
    return fileUploadResponse
      ? fileUploadResponse?.tempUrlTumbs
      : vehiclePlaceHolderImage;
  };
  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <NavBar enableBack={false} title={t("pages.vehicleList.title")} />
      <MenuBar myRef={myRef} activeTab={2} />
      {loading ? (
        <CustomLoader />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {vehiclesList?.length > 0 && (
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
                margin: 10,
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Segoe UI",
                  fontSize: 16,
                  fontWeight: 700,
                  textAlign: "right",
                  color: "#1D5AB9",
                  top: 98,
                  marginLeft: 2,
                }}
                variant="buttonText"
              >
                {t("pages.vehicleList.pageHeading")}
              </Typography>

              <Button
                onClick={() => {
                  if (smDown) {
                    navigate("/addVehicles");
                    return;
                  }
                  setDialogOpen(true);
                }}
                variant="contained"
                style={{
                  width: 98,
                  height: 32,
                  marginLeft: 88,
                  display: "flex",
                }}
              >
                <Typography variant="buttonText" color="common.buttonText">
                  + {t("pages.vehicleList.text01")}
                </Typography>
              </Button>
            </div>
          )}
          <List
            sx={{
              bgcolor: "background.paper",
              width: "100%",
              minHeight: vehiclesList?.length > 0 ? "60vh" : "20vh",
              overflow: "auto",
              maxHeight: "100%",
            }}
          >
            {vehiclesList?.length > 0 &&
              vehiclesList?.map((v, index) => {
                return (
                  <div key={index}>
                    <div
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        display: "flex",
                      }}
                    >
                      <ListItem
                        style={{ cursor: "pointer" }}
                        alignItems="center"
                        onClick={() => handleListItemClick(v)}
                      >
                        <ImageListItem>
                          <img
                            alt=""
                            style={{
                              width: 60,
                              height: 60,
                              top: 12,
                              left: 25,
                              borderRadius: 8,
                            }}
                            loading="lazy"
                            src={getVehicleSource(v)}
                          />
                        </ImageListItem>
                        <ListItemText
                          primary={
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                              }}
                            >
                              <Typography
                                color="text.primary"
                                style={{
                                  fontFamily: "Segoe UI",
                                  fontSize: 16,
                                  fontWeight: 600,
                                  textAlign: "left",
                                  letterSpacing: "0.5%",
                                  textTransform: "uppercase",
                                }}
                              >
                                {t("pages.vehicleList.text04")}:{" "}
                                {v.lic_plate_num}
                              </Typography>
                              <Typography
                                style={{
                                  fontFamily: "Segoe UI",
                                  fontSize: 12,
                                  fontWeight: 400,
                                  textAlign: "center",
                                  letterSpacing: "0.5%",
                                  marginLeft: 8,
                                  borderRadius: 5,
                                  backgroundColor: "#80BCFF33",
                                  padding: "2px 3%",
                                }}
                              >
                                {getVehicleType(v.veh_type_cd)}
                              </Typography>
                            </div>
                          }
                          style={{
                            fontFamily: "Segoe UI",
                            fontSize: 16,
                            fontWeight: 600,
                            textAlign: "left",
                            letterSpacing: "0.5%",
                          }}
                          sx={{ marginLeft: 2 }}
                          secondary={
                            <React.Fragment>
                              <Typography
                                sx={{ display: "inline" }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                                {v.veh_type_cd === "Trailer" ||
                                v.veh_type_cd === "TRALR"
                                  ? `Trailer No: ${
                                      v?.trailerNumber ? v.trailerNumber : "NA"
                                    }`
                                  : `${t("pages.vehicleList.text03")}: ${
                                      v.make || "NA"
                                    }  `}
                                <br></br>
                              </Typography>
                              <Typography
                                sx={{ display: "inline" }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                                {v.veh_type_cd === "Trailer" ||
                                v.veh_type_cd === "TRALR"
                                  ? ""
                                  : `${t("pages.vehicleList.text05")}: ${
                                      v.model || "NA"
                                    }  `}
                                <br></br>
                              </Typography>
                              <Typography
                                sx={{ display: "inline" }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                                {v.veh_type_cd === "Trailer" ||
                                v.veh_type_cd === "TRALR"
                                  ? ``
                                  : `${t("pages.vehicleList.text06")}: ${
                                      v.color
                                    }`}{" "}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                        <ChevronRightIcon
                          style={{
                            color: "grey",
                            width: 40,
                            height: 40,
                          }}
                        />
                      </ListItem>
                    </div>
                    <Divider
                      variant="fullWidth"
                      color="gray"
                      style={{ width: "100%" }}
                    />
                  </div>
                );
              })}
            <div style={{ marginBottom: 60 }} />
          </List>
          <img
            src={addVehiclePlaceHolder}
            hidden={!!vehiclesList?.length}
            style={{
              width: 317,
              height: 240,
              top: 135,
              alignSelf: "center",
            }}
            alt=""
          />
          {!vehiclesList?.length && (
            <Button
              onClick={() => {
                if (smDown) {
                  navigate("/addVehicles");
                  return;
                }
                setDialogOpen(true);
              }}
              variant="contained"
              style={{
                width: 199,
                height: 32,
                margin: "auto",
                marginTop: "10%",
                // marginTop: 20,
                marginBottom: "20%",
                display: "flex",
              }}
            >
              <Typography variant="buttonText" color="common.buttonText">
                + {t("pages.addVehicle.pageHeading")}
              </Typography>
            </Button>
          )}
        </div>
      )}
      <CustomDialog
        title={t("pages.addVehicle.pageHeading")}
        Content={AddVehicles}
        isOpen={isDialogOpen}
        reset={() => setDialogOpen(false)}
      />
      <BottomNav activeTab={2} />
    </div>
  );
};

export default VehiclesList;
